import React from 'react';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';
import Logo from '../assets/img/my-le-logo.png';

// Light mode full-screen loader using existing app spinner
export default function FullScreenLoader({ message = 'Loading…' }) {
  return (
    <div style={styles.wrapper} role="status" aria-live="polite">
      <div style={styles.box}>
        <img src={Logo} alt="LightEdge" style={styles.logo} />
        <LoadingSpinner />
        <div style={styles.text}>{message}</div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#ffffff', zIndex: 9998,
    fontFamily: 'Encode Sans, Roboto, system-ui, sans-serif', color: '#1b2533'
  },
  box: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, minWidth: 180 },
  logo: {
    width: 'clamp(48px, 12vw, 96px)',
    height: 'auto',
    aspectRatio: '1 / 1',
    borderRadius: 16,
    boxShadow: '0 4px 16px rgba(0,0,0,.08)',
    objectFit: 'contain'
  },
  text: { fontSize: 13, letterSpacing: '.05em', textTransform: 'uppercase', opacity: .7 }
};
